import { extendTailwindMerge } from "tailwind-merge";
import type { ClassNameValue } from "tailwind-merge";

const twMerge = extendTailwindMerge({
    extend: {
        theme: {
            text: ["display-xs", "display-sm", "display-md", "display-lg", "display-xl", "display-2xl"],
        },
    },
});

/**
 * This function is a wrapper around the twMerge function.
 * It is used to merge the classes inside style objects.
 *
 * Every className produced here is tagged with `uui-scope`. Untitled UI
 * tokens like `bg-primary`/`text-primary`/`border-primary` share their name
 * with shadcn/ui's brand-color tokens (see global.css), which otherwise
 * forces every `bg-primary` etc. in the app to the brand green — including
 * inside Untitled UI components, where `primary` means "default surface",
 * not "brand color". The `uui-scope` marker lets global.css re-target just
 * these components with higher-specificity rules, without touching the
 * hundreds of legacy shadcn call sites that correctly rely on the green.
 */
export const cx = (...classLists: ClassNameValue[]): string => twMerge(...classLists, "uui-scope");

/**
 * This function does nothing besides helping us to be able to
 * sort the classes inside style objects which is not supported
 * by the Tailwind IntelliSense by default.
 */
export function sortCx<T extends Record<string, string | number | Record<string, string | number | Record<string, string | number>>>>(classes: T): T {
    return classes;
}
